<ng-container *ngIf="!isQuoteSent">
  <div
    class="dq-page"
    [ngClass]="{ 'dq-page--result': !!cancelQuote }"
  >
    <div class="dq-shell">
      <div class="dq-brand dq-brand--image">
        <img
          class="dq-brand__logo"
          [src]="branding?.logoSrc"
          [alt]="branding?.logoAlt || 'FI Galaxy'"
        />
      </div>

      <div class="dq-layout" [ngClass]="{ 'dq-layout--result': !!cancelQuote }">
        <div class="dq-card">
          <div class="dq-card__header">
            <h1>Get a New Cancellation Quote</h1>
            <p>Fill in all the information below to begin.</p>
          </div>

          <form
            [formGroup]="quoteForm"
            (ngSubmit)="handleFormSubmit()"
            class="dq-form"
          >
            <div
              class="dq-contract-box"
              [ngClass]="{ 'dq-contract-box--result': !!cancelQuote }"
            >
              <div *ngIf="!cancelQuote" class="dq-eyebrow">Find your contract</div>
              <div class="dq-contract-grid">
                <div>
                  <label>Search By</label>
                  <select
                    class="dq-field"
                    [(ngModel)]="selectedContractOption"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onContractSearchChange()"
                  >
                    <option
                      *ngFor="let option of searchContractOptions"
                      [value]="option.key"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                <div>
                  <label>Contract</label>
                  <p-autoComplete
                    (completeMethod)="handleContractQueryChange($event)"
                    (onBlur)="handleContractBlur()"
                    (onFocus)="handleContractFocus()"
                    (ngModelChange)="handleContractChange($event)"
                    (onSelect)="handleSelectContract($event)"
                    (onShow)="contractsFilter.paginationScrolling()"
                    [field]="'contract_number'"
                    [suggestions]="contractsFilter.suggestions"
                    formControlName="contract"
                    [inputStyle]="{ height: '52px' }"
                    inputStyleClass="dq-field"
                    placeholder="Search to select contract"
                  >
                    <ng-template let-item pTemplate="item">
                      VIN: {{ item["vin"] }} | Contract #:
                      {{ item["contract_number"] }}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div *ngIf="isContractSelected" class="dq-verified">
                <span>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#fff"
                    stroke-width="3.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <strong>Contract verified - the field is valid.</strong>
              </div>
              <p
                *ngIf="contractsFilter.noData && contractsFilter.searchQuery?.query?.length >= 2"
                class="dq-error"
              >
                No matches exist for their search
              </p>
              <p
                *ngIf="isContractFieldTriggered && !isContractSelected"
                class="dq-error"
              >
                You must select a contract to continue.
              </p>
              <ng-container
                *ngTemplateOutlet="formErrors; context: { control: 'contract' }"
              ></ng-container>
            </div>

            <div class="dq-details-grid">
              <div>
                <label>Cancellation Date</label>
                <input
                  class="dq-field"
                  type="date"
                  [value]="canceledAtInputValue"
                  (change)="handleCanceledAtInput($event)"
                />
                <ng-container
                  *ngTemplateOutlet="formErrors; context: { control: 'canceled_at' }"
                ></ng-container>
              </div>
              <div>
                <label>Mileage at Cancellation</label>
                <input
                  class="dq-field"
                  formControlName="odometer"
                  type="number"
                  placeholder="Enter mileage"
                />
                <ng-container
                  *ngTemplateOutlet="formErrors; context: { control: 'odometer' }"
                ></ng-container>
              </div>
              <div>
                <label>Cancellation Reason</label>
                <select class="dq-field" formControlName="reason_id">
                  <option [ngValue]="null">Select reason</option>
                  <option
                    *ngFor="let reason of cancellationReasonOptions"
                    [ngValue]="reason.id"
                  >
                    {{ reason.name || reason.label }}
                  </option>
                </select>
                <ng-container
                  *ngTemplateOutlet="formErrors; context: { control: 'reason_id' }"
                ></ng-container>
              </div>
            </div>

            <div *ngIf="!!quoteForm.value?.reason_id" class="dq-upload">
              <label>Upload Supporting Documents</label>
              <app-upload-file
                [allowMultiple]="true"
                [form]="quoteForm"
                [title]="''"
                controlName="files"
                [accept]="acceptedFormats"
              ></app-upload-file>
            </div>

            <div>
              <label>Your Email</label>
              <input
                class="dq-field"
                formControlName="email"
                type="email"
                placeholder="Enter your email"
                [ngClass]="{ 'dq-field--filled': !!cancelQuote }"
              />
              <ng-container
                *ngTemplateOutlet="formErrors; context: { control: 'email' }"
              ></ng-container>
            </div>

            <button
              class="dq-btn dq-btn--primary"
              [disabled]="quoteForm.invalid || isLoading"
            >
              Get Quote Now
            </button>

            <div
              *ngIf="cancelQuote"
              class="dq-load-inline"
            >
              <label>Load Quote by Reference</label>
              <div>
                <input
                  class="dq-field"
                  formControlName="quote_reference"
                  type="text"
                  placeholder="Enter quote reference"
                />
                <button
                  type="button"
                  class="dq-btn dq-btn--secondary dq-btn--load"
                  [disabled]="!quoteForm.value?.quote_reference"
                  (click)="handleLoadQuote()"
                >
                  Load
                </button>
              </div>
            </div>
          </form>

          <div *ngIf="!cancelQuote" class="dq-reference">
            <div class="dq-eyebrow">Already have a quote?</div>
            <div class="dq-reference__row">
              <div>
                <label>Load Quote by Reference</label>
                <input
                  class="dq-field"
                  [formControl]="quoteReferenceControl"
                  type="text"
                  placeholder="Enter quote reference"
                />
              </div>
              <button
                type="button"
                class="dq-btn dq-btn--secondary"
                [disabled]="!quoteForm.value?.quote_reference"
                (click)="handleLoadQuote()"
              >
                Load Quote
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="cancelQuote" class="dq-result-panel">
          <div class="dq-result-panel__header">
            <div>
              <span>Reference #</span>
              <strong>{{ cancelQuote?.cancellation_quote_reference_code }}</strong>
            </div>
            <button class="dq-result-action" type="button" (click)="handlePrint()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#9b8cf0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              Download Quote
            </button>
          </div>

          <div class="dq-summary-block">
            <h2>Origination Cost</h2>
            <div>
              <span>Original Retail Cost</span>
              <strong>{{ cancelQuote?.retail_cost | formattedCurrency }}</strong>
            </div>
          </div>

          <div class="dq-summary-block">
            <h2>Factor</h2>
            <div *ngIf="cancelQuote?.is_vsc_product; else defaultFactor">
              <ng-container
                *ngIf="
                  (cancelQuote?.factors?.term || 0) <
                    (cancelQuote?.factors?.mileage || 0);
                  else mileageFactor
                "
              >
                <span>Term (%)</span>
                <strong class="dq-positive">{{ cancelQuote?.factors?.term }}%</strong>
              </ng-container>
              <ng-template #mileageFactor>
                <span>Mileage (%)</span>
                <strong class="dq-positive">{{ cancelQuote?.factors?.mileage }}%</strong>
              </ng-template>
            </div>
            <ng-template #defaultFactor>
              <div>
                <span>Term (%)</span>
                <strong class="dq-positive">
                  {{ cancelQuote?.factors?.term || 0 }}%
                </strong>
              </div>
            </ng-template>
          </div>

          <div class="dq-summary-block">
            <h2>Cancellation Deductions</h2>
            <div>
              <span>Cancellation Fee</span>
              <strong>{{ cancelQuote?.cancellation_fee | formattedCurrency }}</strong>
            </div>
            <div>
              <span>Claims Paid</span>
              <strong>{{ cancelQuote?.claims_paid_amount | formattedCurrency }}</strong>
            </div>
          </div>

          <div class="dq-final-quote">
            <span>Final Quote<span>*</span></span>
            <strong>
              {{ cancelQuote?.cancellation_refund_amount | formattedCurrency }}
            </strong>
          </div>

          <div class="dq-disclaimer">
            <h2>Cancellation Quote Disclaimer</h2>
            <p>
              By proceeding with this cancellation quote, you acknowledge and agree
              to the following:
            </p>
            <ul>
              <li>
                This quote is an estimate based on the information provided and is
                valid for 30 days from the issue date.
              </li>
              <li>
                Final refund amounts are subject to verification of contract
                status, mileage, and claims history.
              </li>
              <li>
                Cancellation fees and paid claims are deducted from the refundable
                amount where applicable.
              </li>
            </ul>
          </div>

          <label class="dq-agree">
            <input
              type="checkbox"
              [checked]="isTermsChecked"
              (change)="isTermsChecked = $any($event.target).checked"
            />
            <span class="dq-agree__box"></span>
            <strong>I agree to the terms & conditions listed above.</strong>
          </label>

          <button
            class="dq-send-btn"
            type="button"
            [disabled]="!isTermsChecked"
            (click)="handleQuoteSend()"
          >
            Send Cancellation Request
          </button>

          <button class="dq-new-quote" type="button" (click)="handleQuoteReset()">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#94a0b4"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
            <span>Get a New Quote</span>
          </button>
        </div>
      </div>
    </div>

    <div class="dq-powered">
      <span>Powered by</span>
      <img src="./assets/images/fi-galaxy.svg" alt="FI Galaxy" />
    </div>
  </div>

  <section hidden id="cancel-quote-print-section">
    <div class="print-section">
      <header>
        <h3>{{ quoteForm.value?.contract?.customers?.[0]?.name }}</h3>
        <div class="contract-title">
          <p class="contract-title-reference">Reference #</p>
          <p>{{ quoteForm.value?.contract?.reference_code }}</p>
        </div>
      </header>
      <hr />
      <div class="product-data">
        <h2>Product Name</h2>
        <p>{{ quoteForm.value?.contract?.products?.[0]?.label }}</p>
      </div>
      <hr />
      <div class="print-cancel-content">
        <div class="print-row">
          <p>Cancellation Fee</p>
          <strong>{{ cancelQuote?.cancellation_fee | formattedCurrency }}</strong>
        </div>
        <div class="print-row">
          <p>Cancellation %</p>
          <strong>{{ cancelQuote?.factors?.cancel }}%</strong>
        </div>
        <div class="print-row">
          <p>Claims Paid</p>
          <strong>{{ cancelQuote?.claims_paid_amount | formattedCurrency }}</strong>
        </div>
        <div class="print-row print-row--primary">
          <p>Final Quote*</p>
          <strong>
            {{ cancelQuote?.cancellation_refund_amount | formattedCurrency }}
          </strong>
        </div>
        <div class="print-row">
          <p>Date of Submission</p>
          <strong>{{ quoteGeneratedAt | date: 'MM/dd/yyyy' }}</strong>
        </div>
        <div class="print-row">
          <p>Cancellation Date</p>
          <strong>{{ quoteForm.value?.canceled_at | date: 'MM/dd/yyyy' }}</strong>
        </div>
        <div class="print-row">
          <p>Cancellation Mileage</p>
          <strong>{{ quoteForm.value?.odometer || 0 }}</strong>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<app-cancel-info *ngIf="isQuoteSent"></app-cancel-info>
<app-ngx-loader [loading]="isLoading"></app-ngx-loader>

<ng-template #formErrors let-control="control">
  <app-form-errors
    [color]="'danger'"
    [control]="quoteForm.get(control)"
    [form]="quoteForm"
  ></app-form-errors>
</ng-template>
